<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { PRICES } from '@presentation/Types/Settings';
import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

const presentation = usePresentation();

</script><template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16 w-full">

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-center font-semibold">Real benefits for your customers</div>
                <div class="mb-6 text-xs 4xl:text-base text-center">Covered Items Limits (Per Work Order) Parts and Labour excluding GST</div>

                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full
                    border-collapse rounded-lg ring-4 ring-black/10 shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-xs text-white">
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tl-lg p-1 lg:p-2 text-left">Consumer Claims</td>
                            <td class="bg-[#2b85be] ring-1 ring-white p-1 md:p-4">New / Demo<br/>Vehicles</td>
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tr-lg p-1 md:p-4 ">Used<br/>Vehicles</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,000
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $920
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $92
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $194
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $555
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $42
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $54
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $355
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,000
                            </td>
                        </tr>

                        <tr class="font-bold text-xs 2xl:text-sm">
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] rounded-bl-lg p-1 lg:p-2 text-left leading-tight">Max claim amount<br/>over 3 year contract</td>
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] p-1 lg:p-2  border-gray-950">$8,159</td>
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] rounded-br-lg p-1 lg:p-2">$11,581</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-6 text-xs 2xl:text-base text-center">What's in it for your customers</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-center font-semibold">Real benefits for your dealership</div>
                <div class="mb-6 text-xs 4xl:text-base text-center">Potential Labour rate per item, per category, per policy</div>

                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full
                    border-collapse rounded-lg ring-4 ring-black/10 shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-xs text-white">
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tl-lg p-1 lg:p-2 text-left">Service Department Work Orders</td>
                            <td class="bg-[#2b85be] ring-1 ring-white p-1 md:p-4">New / Demo<br/>Vehicles</td>
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tr-lg p-1 md:p-4">Used<br/>Vehicles</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $840
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,080
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $840
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $1,080
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $84
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $108
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $105
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $135
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $252
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $324
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $420
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm border-l border-gray-300">
                                $540
                            </td>
                        </tr>

                        <tr class="font-bold text-xs 2xl:text-sm">
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] rounded-bl-lg p-1 lg:p-2 text-left leading-tight">Additional profit<br/>from work orders</td>
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] p-1 lg:p-2">$2,541</td>
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] rounded-br-lg p-1 lg:p-2">$3,267</td>
                        </tr>
                    
                    </tbody>
                    
                </table>

                <div class="mt-6 text-xs 2xl:text-base text-center">What's in it for <span class="uppercase font-semibold text-[#2b85be]">your</span> bottom line</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

        </div>


    </Page>

</template>